import { apiClient } from '../services/apiClient';
import type { DatabasePhoto, Photo, PhotosByEvent } from '../types';
import type { PhotoDisplayData } from '../types/PhotoDisplayData';

// Static photos get negative ids, one block of this many per event, so they never collide with database ids.
const STATIC_PHOTO_ID_STRIDE = 1000;

export const toMediaUrl = (photoId: number): string => apiClient.mediaUrl(photoId);

export const toDisplayPhoto = (photo: DatabasePhoto, eventName: string): PhotoDisplayData => ({
  id: photo.id,
  eventId: photo.eventId,
  eventName,
  url: toMediaUrl(photo.id),
  type: photo.mediaType,
  caption: photo.caption ?? undefined,
  displayOrder: photo.displayOrder,
  audience: photo.audience
});

export const convertEventPhotosToDisplayData = (eventData: PhotosByEvent[string]): PhotoDisplayData[] =>
  eventData ? eventData.photos.map((photo) => toDisplayPhoto(photo, eventData.event.name)) : [];

export const convertDatabasePhotosToPhotos = (photos: DatabasePhoto[]): Photo[] =>
  photos.map((photo) => ({ url: toMediaUrl(photo.id), type: photo.mediaType, caption: photo.caption ?? undefined }));

const getEventIdByName = (photosByEvent: PhotosByEvent, eventName: string): number =>
  photosByEvent[eventName]?.event.id ?? 0;

export const convertStaticPhotosToDisplayData = (photos: Photo[], eventName: string, photosByEvent: PhotosByEvent): PhotoDisplayData[] => {
  const eventId = getEventIdByName(photosByEvent, eventName);
  return photos.map((photo, index) => ({
    id: -(eventId * STATIC_PHOTO_ID_STRIDE + index + 1),
    eventId,
    eventName,
    url: photo.url,
    type: photo.type,
    caption: photo.caption,
    displayOrder: index,
    // Static fallback photos have no database row to carry an audience.
    audience: 'PERSONAL'
  }));
};
